module.exports = __webpack_public_path__ + "img/hakuna_h.64e2570f.png";